<template>
  <router-link to="/blackfriday" class="black-friday is-block">
    <!-- <div class="columns  is-multiline" v-if="$whitelabel.short.toLowerCase() === 'adac'">
      <div class="column is-8-tablet is-offset-2-tablet is-6-desktop is-offset-0-desktop black-friday__content black-friday__content--adac mt-3">
        <div class="has-text-centered-touch black-friday__text--adac">
          <p class="has-background-secondary is-size-5 is-size-3-tablet  is-inline-block has-text-weight-bold has-text-white pr-1 pl-1 mb-3">
            ADAC Hotelgutschein
          </p>

          <p class="title is-inline-block is-size-4 is-size-3-tablet has-text-weight-bold is-uppercase u-p05 has-text-white">Black Week 22. - 28.11.2021</p>
                  </div>
      </div>
      <div class="column is-12-tablet is-6-desktop pl-6 pr-6 pt-5 pb-5 black-friday__img--adac">
        <p class=" has-text-centered has-text-right-desktop">
          <img fetchpriority="high" :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=800&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/black-friday.png`" alt="Black Friday" width="781" height="326" />
        </p>
      </div>
    </div> -->

    <div class="columns  is-multiline is-vcentered" v-if="$whitelabel.short.toLowerCase() === 'adac'">
      <div
        class="column is-8-tablet is-offset-2-tablet is-5-widescreen is-5-desktop is-offset-0-desktop blackfriday__content blackfriday__content--adac mt-3">
        <div class="has-text-centered-touch blackfriday__text--adac">
          <div
            class="title is-inline-block is-size-3-mobile is-size-2-tablet is-size-1-widescreen has-text-weight-bold ">
            <p
              class="has-background-secondary is-size-5 is-size-3-tablet is-size-2-fullhd is-inline-block has-text-weight-bold has-text-white pr-1 pl-1 mb-3">
              ADAC Hotelgutschein
            </p>

            <div
              class="is-size-1-tablet is-size-2-desktop is-size-1-widescreen has-text-white blackfriday__headline--adac">
              <p>Black Week</p>
              <p style="line-height: 0.5">22. - 28.11.2021</p>
            </div>
          </div>

          <b-button tag="router-link" to="/blackfriday" type="is-light" size="is-medium" class="mt-5 is-hidden-touch"
            icon-left="angle-double-right">
            Hier klicken!
          </b-button>
        </div>
      </div>
      <div class="column is-12-tablet is-7-widescreen is-7-desktop blackfriday__img--adac my-0">
        <p class=" has-text-centered has-text-right-desktop">
          <img fetchpriority="high"
            :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=800&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/black-friday.png`"
            alt="Balck Friday" width="781" height="326" />
        </p>
      </div>
    </div>

    <div class="columns" v-if="$whitelabel.short.toLowerCase() !== 'adac'">
      <div class="column is-6 has-text-centered">
        <img fetchpriority="high"
          :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=500&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/black-friday.png`"
          :srcset="`https://assets.urlaubsgutschein.kaufen/i/resize?width=500&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/black-friday.png 500w,
                            https://assets.urlaubsgutschein.kaufen/i/resize?width=370&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/black-friday.png 370w,
                            https://assets.urlaubsgutschein.kaufen/i/resize?width=280&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/black-friday.png 280w`
            " sizes="(max-width: 500px) 100vw, 400px" alt="Black Friday Week" width="400" height="300" />
      </div>
      <div class="column black-friday__content">
        <div class="has-text-centered-mobile">
          <p
            class="title has-background-white has-text-black is-inline-block is-size-6 is-size-3-tablet has-text-weight-bold is-uppercase u-pl15 u-pr15 u-p05">
            Black Friday Week</p>
          <p class=" has-text-white is-size-6 is-size-5-tablet has-text-weight-normal">21. November - 29. November</p>

          <b-button tag="router-link" to="/blackfriday" type="is-dark" inverted outlined class="mt-5 mb-5">
            Zu den Angeboten
          </b-button>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'BlackFriday',

  props: {},
  methods: {},
}
</script>

<style scoped lang="scss">
.black-friday {
  background-color: #000;

  // .title {
  //   margin-bottom: 0.75rem;
  // }
}

// .black-friday__content {
//   @media screen and (min-width: 769px) {
//     margin-top: 3rem;
//   }
// }

// @media screen and (min-width: 1024px) {
//   .black-friday__text--adac {
//     margin-top: 2rem;
//     margin-bottom: 2rem;
//     margin-left: 4rem;
//     margin-right: 0;
//   }

//   .black-friday__img--adac {
//     margin-top: 1rem;
//     margin-bottom: 1rem;
//   }
// }

// @media screen and (min-width: 1216px) {
//   .black-friday__img--adac {
//     margin-right: 3rem;
//     margin-left: -3rem;
//   }
// }

.blackfriday {
  .title {
    margin-bottom: 0.75rem;
  }
}

.blackfriday__content {
  @media screen and (min-width: 769px) {
    margin-top: 3rem;
  }
}

@media screen and (min-width: 1024px) {
  .blackfriday__text--adac {
    margin-top: 1rem;
    margin-bottom: 2rem;
    margin-left: 3rem;
    margin-right: 0;
  }

  // .blackfriday__img--adac {
  //   margin-top: 1rem;
  //   margin-bottom: 1rem;
  // }
}

// @media screen and (min-width: 1216px) {
//   .blackfriday__img--adac {
//     margin-right: 3rem;
//     margin-left: -4rem;
//   }
// }

@media screen and (min-width: 1418px) {
  .blackfriday__headline--adac {
    font-size: 4rem !important;
  }
}
</style>
